import { render, staticRenderFns } from "./Scalepopupbox.vue?vue&type=template&id=2352eeda&scoped=true"
import script from "./Scalepopupbox.vue?vue&type=script&lang=js"
export * from "./Scalepopupbox.vue?vue&type=script&lang=js"
import style0 from "./Scalepopupbox.vue?vue&type=style&index=0&id=2352eeda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2352eeda",
  null
  
)

export default component.exports